

// import React, { useState, useEffect } from 'react';
// import { Search, BookOpen, School, Landmark, Plus, X, Loader2, Edit2, Trash2 } from 'lucide-react';

// export default function CourseManagement() {
//   const [activeTab, setActiveTab] = useState('courses'); // courses, colleges, universities
//   const [dataList, setDataList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);

//   // ➕ ADDED: Pagination Control Parameters
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Smart Form State Managers
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   const [courseForm, setCourseForm] = useState({ course_code: '', course_name: '', program_type: 'Under-Graduate (UG)', minimum_duration: '3', course_medium: 'English Medium', total_annual_fee: '' });
//   const [collegeForm, setCollegeForm] = useState({ college_name: '', college_code: '', coordinator_name: '', campus_location: '' });
//   const [universityForm, setUniversityForm] = useState({ university_name: '', university_type: 'State University', territorial_jurisdiction: '' });

//   const simpleTabs = [
   
//     { id: 'universities', name: 'University Affiliations', icon: Landmark },
//     { id: 'colleges', name: 'Manage Colleges / LSCs', icon: School },
//     { id: 'courses', name: 'Manage Courses & Fees', icon: BookOpen },
 
//   ];

//   useEffect(() => {
//     fetchData();
//   }, [activeTab, searchTerm]);

//   const fetchData = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
//       const result = await res.json();
//       if (result.success) {
//         setDataList(result.data);
//       } else {
//         setDataList([]);
//       }
//     } catch (err) { 
//       console.error(err); 
//       setDataList([]);
//     } finally { 
//       setTableLoading(false); 
//     }
//   };

//   const handleOpenAddModal = () => {
//     setEditingId(null);
//     setCourseForm({ course_code: '', course_name: '', program_type: 'Under-Graduate (UG)', minimum_duration: '3', course_medium: 'English Medium', total_annual_fee: '' });
//     setCollegeForm({ college_name: '', college_code: '', coordinator_name: '', campus_location: '' });
//     setUniversityForm({ university_name: '', university_type: 'State University', territorial_jurisdiction: '' });
//     setIsModalOpen(true);
//   };

//   const handleOpenEditModal = (item) => {
//     setEditingId(item.id);
//     if (activeTab === 'courses') setCourseForm({ ...item });
//     else if (activeTab === 'colleges') setCollegeForm({ ...item });
//     else setUniversityForm({ ...item });
//     setIsModalOpen(true);
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const targetPayload = activeTab === 'courses' ? courseForm : (activeTab === 'colleges' ? collegeForm : universityForm);
//     const endpoint = editingId ? `update-entry/${editingId}` : 'add-entry';
//     const method = editingId ? 'PUT' : 'POST';

//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/${endpoint}`, {
//         method: method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ targetTab: activeTab, payload: targetPayload })
//       });
//       if ((await res.json()).success) {
//         setIsModalOpen(false);
//         fetchData();
//       }
//     } catch (err) { console.error(err); }
//   };

//   const handleDeleteEntry = async (id) => {
//     if (!window.confirm("Are you sure you want to remove this record?")) return;
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/delete-entry/${id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ targetTab: activeTab })
//       });
//       if ((await res.json()).success) fetchData();
//     } catch (err) { console.error(err); }
//   };


//   // ➕ ADDED: Pagination Slice Computation
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(dataList.length / itemsPerPage);

  

//   return (
//     <div>
//       {/* STEP 1: TOP DYNAMIC CONTROL ROW PANEL */}
//       <div style={styles.topActionBar}>
//         <div style={styles.tabScrollGroup}>
//           {simpleTabs.map((tab) => {
//             const Icon = tab.icon;
//             return (
       
// <button 
//   key={tab.id} 
//   onClick={() => { 
//     setActiveTab(tab.id); 
//     setDataList([]); // Prevent rendering layout mismatch
//     setSearchTerm(''); 
//     setCurrentPage(1); // ➕ ADDED: Reset back to page 1
//   }} 
//   style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}
// >
//   <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
// </button>
//             );
//           })}
//         </div>
//         <button onClick={handleOpenAddModal} style={styles.addBtn}>
//           <Plus size={15} style={{ marginRight: '4px' }} /> 
//           {activeTab === 'courses' ? 'Add New Course' : (activeTab === 'colleges' ? 'Add New College' : 'Add New University')}
//         </button>
//       </div>

//       {/* STEP 2: SIMPLE FILTER TEXT INLINE STRIP */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//         {/* Modify your input field element */}
// <input 
//   type="text" 
//   placeholder={`Search ${activeTab === 'courses' ? 'courses' : activeTab === 'colleges' ? 'colleges' : 'universities'}...`} 
//   value={searchTerm} 
//   onChange={(e) => { 
//     setSearchTerm(e.target.value); 
//     setCurrentPage(1); // ➕ ADDED: Reset page counter on keystroke
//   }} 
//   style={styles.tableSearchInput} 
// />
//         </div>
//         <div style={styles.totalIndicator}>Total Records: <strong style={{ color: '#459bf2' }}>{dataList.length}</strong></div>
//       </div>

//       {/* STEP 3: MASTER CLEAN DATA TABLE GRID */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%' }}>
//           <table style={styles.dataTable}>
//             {activeTab === 'courses' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Course Code</th>
//                     <th style={styles.tableTh}>Course Name</th>
//                     <th style={styles.tableTh}>Category Type</th>
//                     <th style={styles.tableTh}>Duration</th>
//                     <th style={styles.tableTh}>Language Medium</th>
//                     <th style={styles.tableTh}>Annual Fees</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="7" style={styles.noDataTd}>No courses found.</td></tr>
//                   ) : (
//                     currentItems.map((item) =>(
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.course_code}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.course_name}</td>
//                         <td style={styles.tableTd}><span style={styles.badge}>{item.program_type}</span></td>
//                         <td style={styles.tableTd}>{item.minimum_duration} Years</td>
//                         <td style={styles.tableTd}>{item.course_medium}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600', color: '#10b981' }}>₹{Number(item.total_annual_fee).toLocaleString('en-IN')} / Year</td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}

//             {activeTab === 'colleges' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Centre Code</th>
//                     <th style={styles.tableTh}>College Name / LSC Location</th>
//                     <th style={styles.tableTh}>Head Coordinator</th>
//                     <th style={styles.tableTh}>Campus Location Area</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="5" style={styles.noDataTd}>No colleges added yet.</td></tr>
//                   ) : (
//                     currentItems.map((item) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.college_code}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.college_name}</td>
//                         <td style={styles.tableTd}>{item.coordinator_name}</td>
//                         <td style={styles.tableTd}>{item.campus_location}</td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}

//             {activeTab === 'universities' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>S.No</th>
//                     <th style={styles.tableTh}>Affiliated University Name</th>
//                     <th style={styles.tableTh}>University Classification Type</th>
//                     <th style={styles.tableTh}>Territorial Jurisdiction Limits</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="5" style={styles.noDataTd}>No university connections recorded.</td></tr>
//                   ) : (
//                     currentItems.map((item, index) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={styles.tableTd}>{index + 1}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.university_name}</td>
//                         <td style={styles.tableTd}><span style={styles.uniBadge}>{item.university_type}</span></td>
//                         <td style={styles.tableTd}>{item.territorial_jurisdiction}</td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}
//           </table>
//         </div>
//       )}

//       {/* ➕ ADDED: PREMIUM PAGINATION CONTROL REGISTRY TOOLBAR */}
//    {/* ⚡ UPDATED: Renders pagination whenever dataList has items to prevent layout shifting */}
//       {dataList.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button 
//             disabled={currentPage === 1} 
//             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//             style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Previous
//           </button>
//           <span style={styles.pageIndicator}>
//             Page <strong>{currentPage}</strong> of {totalPages || 1}
//           </span>
//           <button 
//             disabled={currentPage === totalPages || totalPages === 0} 
//             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//             style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* DYNAMIC SMART FORM POPUP MODAL */}
//       {isModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px' }}>
//                 {editingId ? 'Modify Record Entry' : 'Create New Record Entry'}
//               </h3>
//               <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
//             <form onSubmit={handleFormSubmit} style={styles.modalForm}>
              
//               {/* RENDERING FIELDS FOR THE COURSES TAB */}
//               {activeTab === 'courses' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Course Code</label>
//                       <input type="text" required placeholder="e.g. 104" value={courseForm.course_code} onChange={(e) => setCourseForm({ ...courseForm, course_code: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Course Category Type</label>
//                       <select value={courseForm.program_type} onChange={(e) => setCourseForm({ ...courseForm, program_type: e.target.value })} style={styles.formSelect}>
//                         <option>Under-Graduate (UG)</option><option>Post-Graduate (PG)</option><option>Diploma Course</option><option>Certificate Course</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Course Full Name</label>
//                     <input type="text" required placeholder="e.g. Bachelor of Business Administration (B.B.A.)" value={courseForm.course_name} onChange={(e) => setCourseForm({ ...courseForm, course_name: e.target.value })} style={styles.formInput} />
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Duration (Years)</label>
//                       <input type="number" required value={courseForm.minimum_duration} onChange={(e) => setCourseForm({ ...courseForm, minimum_duration: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Language Medium</label>
//                       <select value={courseForm.course_medium} onChange={(e) => setCourseForm({ ...courseForm, course_medium: e.target.value })} style={styles.formSelect}>
//                         <option>English Medium</option><option>Tamil Medium</option><option>Dual Medium</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Annual Tuition Fee (₹)</label>
//                     <input type="number" required placeholder="Fees per year" value={courseForm.total_annual_fee} onChange={(e) => setCourseForm({ ...courseForm, total_annual_fee: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               {/* RENDERING FIELDS FOR THE COLLEGES TAB */}
//               {activeTab === 'colleges' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>College / LSC Code</label>
//                       <input type="text" required placeholder="e.g. LSC-01" value={collegeForm.college_code} onChange={(e) => setCollegeForm({ ...collegeForm, college_code: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Head Coordinator Name</label>
//                       <input type="text" required placeholder="Professor name" value={collegeForm.coordinator_name} onChange={(e) => setCollegeForm({ ...collegeForm, coordinator_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>College Facility Name</label>
//                     <input type="text" required placeholder="e.g. MET Academy City Center campus" value={collegeForm.college_name} onChange={(e) => setCollegeForm({ ...collegeForm, college_name: e.target.value })} style={styles.formInput} />
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Campus Location Area</label>
//                     <input type="text" required placeholder="e.g. Karaikudi, Chennai" value={collegeForm.campus_location} onChange={(e) => setCollegeForm({ ...collegeForm, campus_location: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               {/* RENDERING FIELDS FOR THE UNIVERSITIES TAB */}
//               {activeTab === 'universities' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>University Name</label>
//                       <input type="text" required placeholder="e.g. Alagappa University" value={universityForm.university_name} onChange={(e) => setUniversityForm({ ...universityForm, university_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>University Type</label>
//                       <select value={universityForm.university_type} onChange={(e) => setUniversityForm({ ...universityForm, university_type: e.target.value })} style={styles.formSelect}>
//                         <option>State University</option><option>Central University</option><option>Deemed University</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Territorial Jurisdiction Limits</label>
//                     <input type="text" required placeholder="e.g. Tamil Nadu, All India" value={universityForm.territorial_jurisdiction} onChange={(e) => setUniversityForm({ ...universityForm, territorial_jurisdiction: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               <div style={styles.formActionDock}>
//                 <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                 <button type="submit" style={styles.formSaveBtn}>Save Entry Record</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
//   addBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '30px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
//   badge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
//   uniBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500' },
//   actionBtnGroup: { display: 'flex', gap: '6px', alignItems: 'center' },
//   editRowBtn: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   deleteRowBtn: { background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '580px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
//   // Append these design properties into your styles object matrix
//   paginationDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #edf2f7'
//   },
//   pageIndicator: {
//     fontSize: '13px',
//     color: '#475569'
//   },
//   pageBtn: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '6px',
//     padding: '6px 14px',
//     color: '#334155',
//     fontSize: '12.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s'
//   },
//   pageBtnDisabled: {
//     background: '#f8fafc',
//     color: '#94a3b8',
//     cursor: 'not-allowed',
//     borderColor: '#e2e8f0'
//   },
//   formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
// };


// import React, { useState, useEffect } from 'react';
// import { Search, BookOpen, School, Landmark, Plus, X, Loader2, Edit2, Trash2, Upload, FileText } from 'lucide-react';

// export default function CourseManagement() {
//   const [activeTab, setActiveTab] = useState('universities');
//   const [dataList, setDataList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);

//   // Lookups for relational dropdowns
//   const [universityOptions, setUniversityOptions] = useState([]);
//   const [collegeOptions, setCollegeOptions] = useState([]);
//   const [filteredColleges, setFilteredColleges] = useState([]);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Modal State
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   // Form States
//   const [imageFile, setImageFile] = useState(null);
//   const [universityForm, setUniversityForm] = useState({
//     university_name: '', university_type: 'State University', territorial_jurisdiction: '',
//     contact_number: '', email_address: '', coordinator_name: ''
//   });

//   const [collegeForm, setCollegeForm] = useState({
//     university_id: '', college_code: '', college_name: '', coordinator_name: '',
//     campus_location: '', contact_number: '', email_address: ''
//   });

//   const [courseForm, setCourseForm] = useState({
//     university_id: '', college_id: '', course_code: '', course_name: '',
//     program_type: 'Under-Graduate (UG)', eligibility: '10+2 / Higher Secondary',
//     minimum_duration: '3', course_medium: 'English Medium', total_annual_fee: '',
//     structure_type: 'Semester', syllabus_structure: []
//   });


  
//   const simpleTabs = [
//     { id: 'universities', name: 'University Affiliations', icon: Landmark },
//     { id: 'colleges', name: 'Manage Colleges / LSCs', icon: School },
//     { id: 'courses', name: 'Manage Courses & Fees', icon: BookOpen },
//   ];

//   useEffect(() => {
//     fetchData();
//     fetchLookups();
//   }, [activeTab, searchTerm]);

//   const fetchData = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
//       const result = await res.json();
//       if (result.success) setDataList(result.data);
//       else setDataList([]);
//     } catch (err) {
//       console.error(err);
//       setDataList([]);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   const fetchLookups = async () => {
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/lookup-options`);
//       const result = await res.json();
//       if (result.success) {
//         setUniversityOptions(result.universities || []);
//         setCollegeOptions(result.colleges || []);
//       }
//     } catch (err) { console.error(err); }
//   };

//   // Filter Colleges based on selected University in Course Form
//   const handleUniversityChangeInCourse = (uniId) => {
//     setCourseForm(prev => ({ ...prev, university_id: uniId, college_id: '' }));
//     if (uniId) {
//       const matched = collegeOptions.filter(col => String(col.university_id) === String(uniId));
//       setFilteredColleges(matched);
//     } else {
//       setFilteredColleges([]);
//     }
//   };

//   // Handle Dynamic Duration change to build Semester/Year Syllabus blocks
//   const handleDurationOrStructureChange = (duration, type) => {
//     const num = parseInt(duration) || 1;
//     const totalBlocks = type === 'Semester' ? num * 2 : num;
//     let newSyllabus = [];

//     for (let i = 1; i <= totalBlocks; i++) {
//       const label = type === 'Semester' ? `Semester ${i}` : `Year ${i}`;
//       const existing = courseForm.syllabus_structure.find(s => s.term === label);
//       newSyllabus.push({
//         term: label,
//         papers: existing ? existing.papers : ['']
//       });
//     }
//     setCourseForm(prev => ({ ...prev, minimum_duration: duration, structure_type: type, syllabus_structure: newSyllabus }));
//   };

//   const handlePaperChange = (termIndex, paperIndex, val) => {
//     const updated = [...courseForm.syllabus_structure];
//     updated[termIndex].papers[paperIndex] = val;
//     setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
//   };

//   const addPaperInput = (termIndex) => {
//     const updated = [...courseForm.syllabus_structure];
//     updated[termIndex].papers.push('');
//     setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
//   };

//   const removePaperInput = (termIndex, paperIndex) => {
//     const updated = [...courseForm.syllabus_structure];
//     updated[termIndex].papers.splice(paperIndex, 1);
//     setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
//   };

//   const handleOpenAddModal = () => {
//     setEditingId(null);
//     setImageFile(null);
//     setUniversityForm({ university_name: '', university_type: 'State University', territorial_jurisdiction: '', contact_number: '', email_address: '', coordinator_name: '' });
//     setCollegeForm({ university_id: universityOptions[0]?.id || '', college_code: '', college_name: '', coordinator_name: '', campus_location: '', contact_number: '', email_address: '' });
    
//     const initialUni = universityOptions[0]?.id || '';
//     setCourseForm({
//       university_id: initialUni, college_id: '', course_code: '', course_name: '',
//       program_type: 'Under-Graduate (UG)', eligibility: '10+2 / Higher Secondary',
//       minimum_duration: '3', course_medium: 'English Medium', total_annual_fee: '',
//       structure_type: 'Semester', syllabus_structure: []
//     });
//     handleUniversityChangeInCourse(initialUni);
//     setIsModalOpen(true);
//   };

//   const handleOpenEditModal = (item) => {
//     setEditingId(item.id);
//     setImageFile(null);
//     if (activeTab === 'universities') setUniversityForm({ ...item });
//     else if (activeTab === 'colleges') setCollegeForm({ ...item });
//     else {
//       setCourseForm({ ...item, syllabus_structure: item.syllabus_structure || [] });
//       handleUniversityChangeInCourse(item.university_id);
//     }
//     setIsModalOpen(true);
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     const targetPayload = activeTab === 'courses' ? courseForm : (activeTab === 'colleges' ? collegeForm : universityForm);
    
//     formData.append('targetTab', activeTab);
//     formData.append('payload', JSON.stringify(targetPayload));
//     if (imageFile && activeTab === 'universities') {
//       formData.append('header_image', imageFile);
//     }

//     const endpoint = editingId ? `update-entry/${editingId}` : 'add-entry';
//     const method = editingId ? 'PUT' : 'POST';

//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/${endpoint}`, {
//         method: method,
//         body: formData
//       });
//       if ((await res.json()).success) {
//         setIsModalOpen(false);
//         fetchData();
//         fetchLookups();
//       }
//     } catch (err) { console.error(err); }
//   };

//   const handleDeleteEntry = async (id) => {
//     if (!window.confirm("Are you sure you want to remove this record?")) return;
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/delete-entry/${id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ targetTab: activeTab })
//       });
//       if ((await res.json()).success) fetchData();
//     } catch (err) { console.error(err); }
//   };

//   // Pagination Computations
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(dataList.length / itemsPerPage);

//   return (
//     <div>
//       {/* TOP CONTROL ACTION BAR */}
//       <div style={styles.topActionBar}>
//         <div style={styles.tabScrollGroup}>
//           {simpleTabs.map((tab) => {
//             const Icon = tab.icon;
//             return (
//               <button
//                 key={tab.id}
//                 onClick={() => {
//                   setActiveTab(tab.id);
//                   setDataList([]);
//                   setSearchTerm('');
//                   setCurrentPage(1);
//                 }}
//                 style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}
//               >
//                 <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
//               </button>
//             );
//           })}
//         </div>
//         <button onClick={handleOpenAddModal} style={styles.addBtn}>
//           <Plus size={15} style={{ marginRight: '4px' }} />
//           {activeTab === 'courses' ? 'Add New Course' : (activeTab === 'colleges' ? 'Add New College' : 'Add New University')}
//         </button>
//       </div>

//       {/* SEARCH AND INDICATOR STRIP */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//           <input
//             type="text"
//             placeholder={`Search ${activeTab}...`}
//             value={searchTerm}
//             onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//             style={styles.tableSearchInput}
//           />
//         </div>
//         <div style={styles.totalIndicator}>Total Records: <strong style={{ color: '#459bf2' }}>{dataList.length}</strong></div>
//       </div>

//       {/* MASTER DATA TABLE */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%' }}>
//           <table style={styles.dataTable}>
//             {activeTab === 'universities' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>S.No</th>
//                     <th style={styles.tableTh}>University Header Image</th>
//                     <th style={styles.tableTh}>University Name</th>
//                     <th style={styles.tableTh}>Classification</th>
//                     <th style={styles.tableTh}>Coordinator</th>
//                     <th style={styles.tableTh}>Contact & Email</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="7" style={styles.noDataTd}>No university connections recorded.</td></tr>
//                   ) : (
//                     currentItems.map((item, index) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={styles.tableTd}>{index + 1}</td>
//                         <td style={styles.tableTd}>
//                           {item.header_image ? (
//                             <img src={item.header_image} alt="Header" style={{ width: '60px', height: '35px', borderRadius: '4px', objectFit: 'cover' }} />
//                           ) : <span style={{ color: '#94a3b8', fontSize: '11px' }}>No Image</span>}
//                         </td>
//                         <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.university_name}</td>
//                         <td style={styles.tableTd}><span style={styles.uniBadge}>{item.university_type}</span></td>
//                         <td style={styles.tableTd}>{item.coordinator_name || 'N/A'}</td>
//                         <td style={styles.tableTd}>{item.contact_number}<br/><small style={{ color: '#94a3b8' }}>{item.email_address}</small></td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}

//             {activeTab === 'colleges' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Centre Code</th>
//                     <th style={styles.tableTh}>Affiliated University</th>
//                     <th style={styles.tableTh}>College Facility Name</th>
//                     <th style={styles.tableTh}>Coordinator</th>
//                     <th style={styles.tableTh}>Contact Info</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="6" style={styles.noDataTd}>No colleges added yet.</td></tr>
//                   ) : (
//                     currentItems.map((item) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.college_code}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600', color: '#1c6ec9' }}>{item.university_name}</td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.college_name}</td>
//                         <td style={styles.tableTd}>{item.coordinator_name}</td>
//                         <td style={styles.tableTd}>{item.contact_number}<br/><small style={{ color: '#94a3b8' }}>{item.email_address}</small></td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}

//             {activeTab === 'courses' && (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Code</th>
//                     <th style={styles.tableTh}>University / College</th>
//                     <th style={styles.tableTh}>Course Name</th>
//                     <th style={styles.tableTh}>Eligibility</th>
//                     <th style={styles.tableTh}>Type & Duration</th>
//                     <th style={styles.tableTh}>Annual Fees</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="7" style={styles.noDataTd}>No courses found.</td></tr>
//                   ) : (
//                     currentItems.map((item) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.course_code}</td>
//                         <td style={styles.tableTd}>
//                           <strong style={{ color: '#1c6ec9' }}>{item.university_name}</strong>
//                           {item.college_name && <div><small style={{ color: '#64748b' }}>({item.college_name})</small></div>}
//                         </td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.course_name}</td>
//                         <td style={styles.tableTd}><span style={styles.badge}>{item.eligibility}</span></td>
//                         <td style={styles.tableTd}>{item.program_type}<br/><small>{item.minimum_duration} Yrs ({item.structure_type})</small></td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600', color: '#10b981' }}>₹{Number(item.total_annual_fee).toLocaleString('en-IN')} / Yr</td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}
//           </table>
//         </div>
//       )}

//       {/* PAGINATION */}
//       {dataList.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}>Previous</button>
//           <span style={styles.pageIndicator}>Page <strong>{currentPage}</strong> of {totalPages || 1}</span>
//           <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}>Next</button>
//         </div>
//       )}

//       {/* POPUP FORM MODAL */}
//       {isModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px' }}>{editingId ? 'Modify Record Entry' : 'Create New Record Entry'}</h3>
//               <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
//             <form onSubmit={handleFormSubmit} style={styles.modalForm}>
              
//               {/* UNIVERSITIES FORM */}
//               {activeTab === 'universities' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>University Name</label>
//                       <input type="text" required placeholder="e.g. Alagappa University" value={universityForm.university_name} onChange={(e) => setUniversityForm({ ...universityForm, university_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Classification</label>
//                       <select value={universityForm.university_type} onChange={(e) => setUniversityForm({ ...universityForm, university_type: e.target.value })} style={styles.formSelect}>
//                         <option>State University</option><option>Central University</option><option>Deemed University</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Contact Number</label>
//                       <input type="text" required placeholder="Phone number" value={universityForm.contact_number} onChange={(e) => setUniversityForm({ ...universityForm, contact_number: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Email Address</label>
//                       <input type="email" required placeholder="info@university.edu" value={universityForm.email_address} onChange={(e) => setUniversityForm({ ...universityForm, email_address: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Head Coordinator Name</label>
//                       <input type="text" placeholder="Coordinator name" value={universityForm.coordinator_name} onChange={(e) => setUniversityForm({ ...universityForm, coordinator_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Header Image (Optional)</label>
//                       <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Territorial Jurisdiction Limits</label>
//                     <input type="text" required placeholder="e.g. Tamil Nadu, All India" value={universityForm.territorial_jurisdiction} onChange={(e) => setUniversityForm({ ...universityForm, territorial_jurisdiction: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               {/* COLLEGES FORM */}
//               {activeTab === 'colleges' && (
//                 <>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Select Affiliated University</label>
//                     <select required value={collegeForm.university_id} onChange={(e) => setCollegeForm({ ...collegeForm, university_id: e.target.value })} style={styles.formSelect}>
//                       <option value="">-- Choose University --</option>
//                       {universityOptions.map(u => <option key={u.id} value={u.id}>{u.university_name}</option>)}
//                     </select>
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>College / LSC Code</label>
//                       <input type="text" required placeholder="e.g. LSC-01" value={collegeForm.college_code} onChange={(e) => setCollegeForm({ ...collegeForm, college_code: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Coordinator Name</label>
//                       <input type="text" required placeholder="Professor name" value={collegeForm.coordinator_name} onChange={(e) => setCollegeForm({ ...collegeForm, coordinator_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>College Facility Name</label>
//                     <input type="text" required placeholder="e.g. Govt Arts College" value={collegeForm.college_name} onChange={(e) => setCollegeForm({ ...collegeForm, college_name: e.target.value })} style={styles.formInput} />
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Contact Phone</label>
//                       <input type="text" required placeholder="Phone number" value={collegeForm.contact_number} onChange={(e) => setCollegeForm({ ...collegeForm, contact_number: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Contact Email</label>
//                       <input type="email" required placeholder="Email address" value={collegeForm.email_address} onChange={(e) => setCollegeForm({ ...collegeForm, email_address: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Campus Location</label>
//                     <input type="text" required placeholder="Location" value={collegeForm.campus_location} onChange={(e) => setCollegeForm({ ...collegeForm, campus_location: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               {/* COURSES FORM */}
//               {activeTab === 'courses' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Select University *</label>
//                       <select required value={courseForm.university_id} onChange={(e) => handleUniversityChangeInCourse(e.target.value)} style={styles.formSelect}>
//                         <option value="">-- Select University --</option>
//                         {universityOptions.map(u => <option key={u.id} value={u.id}>{u.university_name}</option>)}
//                       </select>
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Select College (Optional)</label>
//                       <select value={courseForm.college_id} onChange={(e) => setCourseForm({ ...courseForm, college_id: e.target.value })} style={styles.formSelect}>
//                         <option value="">-- Independent University Course --</option>
//                         {filteredColleges.map(c => <option key={c.id} value={c.id}>{c.college_name}</option>)}
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Course Code</label>
//                       <input type="text" required placeholder="e.g. 104" value={courseForm.course_code} onChange={(e) => setCourseForm({ ...courseForm, course_code: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Category Type</label>
//                       <select value={courseForm.program_type} onChange={(e) => setCourseForm({ ...courseForm, program_type: e.target.value })} style={styles.formSelect}>
//                         <option>Under-Graduate (UG)</option><option>Post-Graduate (PG)</option><option>Diploma Course</option><option>Certificate Course</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Course Name</label>
//                       <input type="text" required placeholder="e.g. Bachelor of Arts (BA)" value={courseForm.course_name} onChange={(e) => setCourseForm({ ...courseForm, course_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Eligibility Criteria</label>
//                       <select value={courseForm.eligibility} onChange={(e) => setCourseForm({ ...courseForm, eligibility: e.target.value })} style={styles.formSelect}>
//                         <option>10th Pass</option><option>10+2 / Higher Secondary</option><option>Diploma</option><option>Graduate (UG)</option><option>Post Graduate (PG)</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Duration (Years)</label>
//                       <input type="number" required min="1" max="5" value={courseForm.minimum_duration} onChange={(e) => handleDurationOrStructureChange(e.target.value, courseForm.structure_type)} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Language Medium</label>
//                       <select value={courseForm.course_medium} onChange={(e) => setCourseForm({ ...courseForm, course_medium: e.target.value })} style={styles.formSelect}>
//                         <option>English Medium</option><option>Tamil Medium</option><option>Dual Medium</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Annual Tuition Fee (₹)</label>
//                       <input type="number" required placeholder="Fees per year" value={courseForm.total_annual_fee} onChange={(e) => setCourseForm({ ...courseForm, total_annual_fee: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Academic Structure</label>
//                       <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginTop: '6px' }}>
//                         <label style={{ fontSize: '12px', cursor: 'pointer' }}>
//                           <input type="radio" name="struct" value="Semester" checked={courseForm.structure_type === 'Semester'} onChange={(e) => handleDurationOrStructureChange(courseForm.minimum_duration, e.target.value)} /> Semester
//                         </label>
//                         <label style={{ fontSize: '12px', cursor: 'pointer' }}>
//                           <input type="radio" name="struct" value="Non-Semester" checked={courseForm.structure_type === 'Non-Semester'} onChange={(e) => handleDurationOrStructureChange(courseForm.minimum_duration, e.target.value)} /> Non-Semester (Yearly)
//                         </label>
//                       </div>
//                     </div>
//                   </div>

//                   {/* DYNAMIC SYLLABUS / SUBJECT PAPERS BLOCK */}
//                   <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '8px', maxHeight: '180px', overflowY: 'auto' }}>
//                     <label style={{ ...styles.fieldLabel, color: '#1c6ec9', marginBottom: '8px', display: 'block' }}>Syllabus & Subject Papers Breakdown</label>
//                     {courseForm.syllabus_structure.map((block, termIdx) => (
//                       <div key={termIdx} style={{ marginBottom: '12px', background: '#fff', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}>
//                         <strong style={{ fontSize: '12px', color: '#334155' }}>{block.term}</strong>
//                         {block.papers.map((paper, paperIdx) => (
//                           <div key={paperIdx} style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
//                             <input type="text" placeholder={`Paper ${paperIdx + 1} Name`} value={paper} onChange={(e) => handlePaperChange(termIdx, paperIdx, e.target.value)} style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} />
//                             {block.papers.length > 1 && (
//                               <button type="button" onClick={() => removePaperInput(termIdx, paperIdx)} style={{ background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '4px', cursor: 'pointer', padding: '0 6px' }}>✕</button>
//                             )}
//                           </div>
//                         ))}
//                         <button type="button" onClick={() => addPaperInput(termIdx)} style={{ marginTop: '6px', background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', fontSize: '11px', padding: '3px 8px', borderRadius: '4px', cursor: 'pointer' }}>+ Add Paper</button>
//                       </div>
//                     ))}
//                   </div>
//                 </>
//               )}

//               <div style={styles.formActionDock}>
//                 <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                 <button type="submit" style={styles.formSaveBtn}>Save Entry Record</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
//   addBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '30px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
//   badge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
//   uniBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500' },
//   actionBtnGroup: { display: 'flex', gap: '6px', alignItems: 'center' },
//   editRowBtn: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   deleteRowBtn: { background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '620px', maxHeight: '90vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)', overflowY: 'auto' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '14px' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '9px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '9px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
//   formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' },
//   paginationDock: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #edf2f7' },
//   pageIndicator: { fontSize: '13px', color: '#475569' },
//   pageBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '6px 14px', color: '#334155', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer' },
//   pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' }
// };



//10-08-2026


import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Search, BookOpen, School, Landmark, Plus, X, Loader2, Edit2, Trash2, Upload, FileText, Download } from 'lucide-react';

export default function CourseManagement() {
  const [activeTab, setActiveTab] = useState('universities');
  const [dataList, setDataList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);

  // Lookups for relational dropdowns
  const [universityOptions, setUniversityOptions] = useState([]);
  const [collegeOptions, setCollegeOptions] = useState([]);
  const [filteredColleges, setFilteredColleges] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // Form States
  const [imageFile, setImageFile] = useState(null);
  const [universityForm, setUniversityForm] = useState({
    university_name: '', university_type: 'State University', territorial_jurisdiction: '',
    contact_number: '', email_address: '', coordinator_name: ''
  });

  const [collegeForm, setCollegeForm] = useState({
    university_id: '', college_code: '', college_name: '', coordinator_name: '',
    campus_location: '', contact_number: '', email_address: ''
  });

const [courseForm, setCourseForm] = useState({
  university_id: '', 
  college_id: '', 
  course_code: '', 
  course_name: '',
  program_type: 'Under-Graduate (UG)', 
  eligibility: '', // Free-text input
  minimum_duration: '3', 
  course_medium: 'English Medium', 
  total_course_fee: '', // Renamed from total_annual_fee
  assignment_marks: '20',
  structure_type: 'Semester', 
  syllabus_structure: [],
  required_documents: ['10th Marksheet', '12th Marksheet', 'Transfer Certificate (TC)'], // Default checklist
  semester_details: [] // Holds sem-wise fee date, exam month, assignment duration, and result timeline
});


  const simpleTabs = [
    { id: 'universities', name: 'University Affiliations', icon: Landmark },
    { id: 'colleges', name: 'Manage Colleges / LSCs', icon: School },
    { id: 'courses', name: 'Manage Courses & Fees', icon: BookOpen },
  ];

  useEffect(() => {
    fetchData();
    fetchLookups();
  }, [activeTab, searchTerm]);


  // ➕ Export function for active tab data
const handleExportTabToExcel = () => {
  if (dataList.length === 0) {
    alert("No records available to export for this view.");
    return;
  }

  let exportData = [];
  let sheetTitle = "";

  // 1. Universities Tab Data Format
  if (activeTab === 'universities') {
    sheetTitle = "Universities_List";
    exportData = dataList.map((item, index) => ({
      "S.No": index + 1,
      "University Name": item.university_name || 'N/A',
      "Classification": item.university_type || 'N/A',
      "Coordinator Name": item.coordinator_name || 'N/A',
      "Contact Number": item.contact_number || 'N/A',
      "Email Address": item.email_address || 'N/A',
      "Territorial Jurisdiction": item.territorial_jurisdiction || 'N/A'
    }));
  }

  // 2. Colleges Tab Data Format
  else if (activeTab === 'colleges') {
    sheetTitle = "Colleges_LSCs_List";
    exportData = dataList.map((item, index) => ({
      "S.No": index + 1,
      "Centre Code": item.college_code || 'N/A',
      "Affiliated University": item.university_name || 'N/A',
      "College Name": item.college_name || 'N/A',
      "Coordinator Name": item.coordinator_name || 'N/A',
      "Contact Phone": item.contact_number || 'N/A',
      "Contact Email": item.email_address || 'N/A',
      "Campus Location": item.campus_location || 'N/A'
    }));
  }

  // 3. Courses Tab Data Format
  else if (activeTab === 'courses') {
    sheetTitle = "Courses_Fees_List";
    exportData = dataList.map((item, index) => ({
      "S.No": index + 1,
      "Course Code": item.course_code || 'N/A',
      "Affiliated University": item.university_name || 'N/A',
      "College Name": item.college_name || 'Direct University Course',
      "Course Full Name": item.course_name || 'N/A',
      "Eligibility Criteria": item.eligibility || 'N/A',
      "Program Category": item.program_type || 'N/A',
      "Duration (Years)": item.minimum_duration || 'N/A',
      "Academic Structure": item.structure_type || 'Semester',
      "Language Medium": item.course_medium || 'English Medium',
      "Assignment Marks": item.assignment_marks || 'N/A',
      "Total Course Fee (INR)": Number(item.total_course_fee || 0).toLocaleString('en-IN')
    }));
  }

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetTitle);

  const fileName = `${sheetTitle}_Export_${new Date().toISOString().substring(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};


  const fetchData = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
      const result = await res.json();
      if (result.success) setDataList(result.data);
      else setDataList([]);
    } catch (err) {
      console.error(err);
      setDataList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const fetchLookups = async () => {
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/lookup-options`);
      const result = await res.json();
      if (result.success) {
        setUniversityOptions(result.universities || []);
        setCollegeOptions(result.colleges || []);
      }
    } catch (err) { console.error(err); }
  };

  // Filter Colleges based on selected University in Course Form
  const handleUniversityChangeInCourse = (uniId) => {
    setCourseForm(prev => ({ ...prev, university_id: uniId, college_id: '' }));
    if (uniId) {
      const matched = collegeOptions.filter(col => String(col.university_id) === String(uniId));
      setFilteredColleges(matched);
    } else {
      setFilteredColleges([]);
    }
  };

  // Handle Dynamic Duration change to build Semester/Year Syllabus blocks
// const handleDurationOrStructureChange = (duration, type) => {
//   const num = parseInt(duration) || 1;
//   const totalBlocks = type === 'Semester' ? num * 2 : num;
//   let newSyllabus = [];
//   let newSemDetails = [];

//   for (let i = 1; i <= totalBlocks; i++) {
//     const label = type === 'Semester' ? `Semester ${i}` : `Year ${i}`;
    
//     // Preserve syllabus
//     const existingSyllabus = (courseForm.syllabus_structure || []).find(s => s.term === label);
//     newSyllabus.push({
//       term: label,
//       papers: existingSyllabus ? existingSyllabus.papers : ['']
//     });

//     // ⚡ Preserve existing timeline details or assign default fallbacks
//     const existingDetail = (courseForm.semester_details || []).find(d => d.term_label === label);
//     newSemDetails.push({
//       term_label: label,
//       fee_due_date: existingDetail ? existingDetail.fee_due_date : '',
//       assignment_duration: existingDetail ? existingDetail.assignment_duration : '10 Days',
//       exam_schedule_text: existingDetail ? existingDetail.exam_schedule_text : '',
//       results_timeline_text: existingDetail ? existingDetail.results_timeline_text : '45 Days'
//     });
//   }

//   setCourseForm(prev => ({
//     ...prev,
//     minimum_duration: duration,
//     structure_type: type,
//     syllabus_structure: newSyllabus,
//     semester_details: newSemDetails
//   }));
// };


const handleDurationOrStructureChange = (duration, type) => {
  const num = parseInt(duration) || 1;
  const totalBlocks = type === 'Semester' ? num * 2 : num;

  setCourseForm(prev => {
    let newSyllabus = [];
    let newSemDetails = [];

    for (let i = 1; i <= totalBlocks; i++) {
      const label = type === 'Semester' ? `Semester ${i}` : `Year ${i}`;

      // Preserve existing papers from prev state for matching terms
      const existingSyllabus = (prev.syllabus_structure || []).find(s => s.term === label);
      newSyllabus.push({
        term: label,
        papers: (existingSyllabus && existingSyllabus.papers && existingSyllabus.papers.length > 0)
          ? existingSyllabus.papers
          : ['']
      });

      // Preserve existing timeline details from prev state
      const existingDetail = (prev.semester_details || []).find(d => d.term_label === label);
      newSemDetails.push({
        term_label: label,
        semester_fee: existingDetail ? existingDetail.semester_fee : '',
        exam_fee: existingDetail ? existingDetail.exam_fee : '',
        assignment_duration: existingDetail ? existingDetail.assignment_duration : '10 Days',
        exam_schedule_text: existingDetail ? existingDetail.exam_schedule_text : 'May / Dec',
        results_timeline_text: existingDetail ? existingDetail.results_timeline_text : '45 Days'
      });
    }

    return {
      ...prev,
      minimum_duration: duration,
      structure_type: type,
      syllabus_structure: newSyllabus,
      semester_details: newSemDetails
    };
  });
};
  const handlePaperChange = (termIndex, paperIndex, val) => {
    const updated = [...courseForm.syllabus_structure];
    updated[termIndex].papers[paperIndex] = val;
    setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
  };

  const addPaperInput = (termIndex) => {
    const updated = [...courseForm.syllabus_structure];
    updated[termIndex].papers.push('');
    setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
  };

  const removePaperInput = (termIndex, paperIndex) => {
    const updated = [...courseForm.syllabus_structure];
    updated[termIndex].papers.splice(paperIndex, 1);
    setCourseForm(prev => ({ ...prev, syllabus_structure: updated }));
  };


  const handleAddDocument = () => {
  setCourseForm(prev => ({
    ...prev,
    required_documents: [...prev.required_documents, '']
  }));
};

const handleDocumentChange = (index, value) => {
  const updated = [...courseForm.required_documents];
  updated[index] = value;
  setCourseForm(prev => ({ ...prev, required_documents: updated }));
};

const handleRemoveDocument = (index) => {
  const updated = courseForm.required_documents.filter((_, i) => i !== index);
  setCourseForm(prev => ({ ...prev, required_documents: updated }));
};


const handleSemesterDetailChange = (index, field, value) => {
  const updated = [...courseForm.semester_details];
  updated[index][field] = value;
  setCourseForm(prev => ({ ...prev, semester_details: updated }));
};

  // const handleOpenAddModal = () => {
  //   setEditingId(null);
  //   setImageFile(null);
  //   setUniversityForm({ university_name: '', university_type: 'State University', territorial_jurisdiction: '', contact_number: '', email_address: '', coordinator_name: '' });
  //   setCollegeForm({ university_id: universityOptions[0]?.id || '', college_code: '', college_name: '', coordinator_name: '', campus_location: '', contact_number: '', email_address: '' });
    
  //   const initialUni = universityOptions[0]?.id || '';
  //   setCourseForm({
  //     university_id: initialUni, college_id: '', course_code: '', course_name: '',
  //     program_type: 'Under-Graduate (UG)', eligibility: '10+2 / Higher Secondary',
  //     minimum_duration: '3', course_medium: 'English Medium', total_annual_fee: '',
  //     structure_type: 'Semester', syllabus_structure: []
  //   });
  //   handleUniversityChangeInCourse(initialUni);
  //   setIsModalOpen(true);
  // };


// Inside handleOpenAddModal:
const handleOpenAddModal = () => {
  setEditingId(null);
  setImageFile(null);
  setUniversityForm({ university_name: '', university_type: 'State University', territorial_jurisdiction: '', contact_number: '', email_address: '', coordinator_name: '' });
  setCollegeForm({ university_id: universityOptions[0]?.id || '', college_code: '', college_name: '', coordinator_name: '', campus_location: '', contact_number: '', email_address: '' });
  
  const initialUni = universityOptions[0]?.id || '';
  
  setCourseForm({
    university_id: initialUni,
    college_id: '',
    course_code: '',
    course_name: '',
    program_type: 'Under-Graduate (UG)',
    eligibility: '',
    minimum_duration: '3',
    course_medium: 'English Medium',
    total_course_fee: '',
    assignment_marks: '20',
    structure_type: 'Semester',
    syllabus_structure: [],
    required_documents: ['10th Marksheet', '12th Marksheet', 'Transfer Certificate (TC)'],
    semester_details: [] 
  });

  handleUniversityChangeInCourse(initialUni);
  
  // ⚡ ADD THIS LINE: Automatically builds the 6 semester timeline objects
  handleDurationOrStructureChange('3', 'Semester'); 
  
  setIsModalOpen(true);
};

// Inside handleOpenEditModal:
const handleOpenEditModal = async (item) => {
  setEditingId(item.id);
  setImageFile(null);

  if (activeTab === 'universities') {
    setUniversityForm({ ...item });
  } else if (activeTab === 'colleges') {
    setCollegeForm({ ...item, university_id: item.university_id || '' });
  } 
  
  
else {
  let semDetails = item.semester_details || [];

  // 1. Fetch saved semester timeline rows if empty
  if (semDetails.length === 0) {
    try {
      const semRes = await fetch(`https://metapi.emedhatechnologies.com/api/courses/semester-details/${item.id}`);
      const semData = await semRes.json();
      if (semData.success && semData.data.length > 0) {
        semDetails = semData.data;
      }
    } catch (err) {
      console.error("Failed to fetch sem details:", err);
    }
  }

  // 2. Safely parse syllabus_structure JSON string
  let parsedSyllabus = [];
  if (typeof item.syllabus_structure === 'string') {
    try {
      parsedSyllabus = JSON.parse(item.syllabus_structure);
    } catch (e) {
      console.error("Failed to parse syllabus_structure JSON string:", e);
      parsedSyllabus = [];
    }
  } else if (Array.isArray(item.syllabus_structure)) {
    parsedSyllabus = item.syllabus_structure;
  }

  // 3. Safely parse required_documents JSON string
  let parsedDocs = ['10th Marksheet', '12th Marksheet'];
  if (typeof item.required_documents === 'string') {
    try {
      parsedDocs = JSON.parse(item.required_documents);
    } catch (e) {
      parsedDocs = ['10th Marksheet', '12th Marksheet'];
    }
  } else if (Array.isArray(item.required_documents)) {
    parsedDocs = item.required_documents;
  }

  // ⚡ STEP 1 FIX: Build a fallback syllabus directly in memory instead of calling handleDurationOrStructureChange
  const durationNum = parseInt(item.minimum_duration) || 1;
  const structType = item.structure_type || 'Semester';
  const totalBlocks = structType === 'Semester' ? durationNum * 2 : durationNum;

  if (!parsedSyllabus || parsedSyllabus.length === 0) {
    parsedSyllabus = [];
    for (let i = 1; i <= totalBlocks; i++) {
      const label = structType === 'Semester' ? `Semester ${i}` : `Year ${i}`;
      parsedSyllabus.push({ term: label, papers: [''] });
    }
  }

  // ⚡ STEP 2 FIX: Build fallback semester details in memory if missing
  if (!semDetails || semDetails.length === 0) {
    semDetails = [];
    for (let i = 1; i <= totalBlocks; i++) {
      const label = structType === 'Semester' ? `Semester ${i}` : `Year ${i}`;
      semDetails.push({
        term_label: label,
        semester_fee: '',
        exam_fee: '',
        assignment_duration: '10 Days',
        exam_schedule_text: 'May / Dec',
        results_timeline_text: '45 Days'
      });
    }
  }

  // 4. Update College Filter Options without wiping college_id
  if (item.university_id) {
    const matched = collegeOptions.filter(col => String(col.university_id) === String(item.university_id));
    setFilteredColleges(matched);
  } else {
    setFilteredColleges([]);
  }

  // 5. Commit clean atomic state update once
  setCourseForm({
    university_id: item.university_id || '',
    college_id: item.college_id || '',
    course_code: item.course_code || '',
    course_name: item.course_name || '',
    program_type: item.program_type || 'Under-Graduate (UG)',
    eligibility: item.eligibility || '',
    minimum_duration: String(item.minimum_duration || '3'),
    course_medium: item.course_medium || 'English Medium',
    total_course_fee: item.total_course_fee || item.total_annual_fee || '',
    assignment_marks: String(item.assignment_marks || '20'),
    structure_type: structType,
    syllabus_structure: parsedSyllabus,
    required_documents: parsedDocs,
    semester_details: semDetails
  });
}
  setIsModalOpen(true);
};

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const targetPayload = activeTab === 'courses' ? courseForm : (activeTab === 'colleges' ? collegeForm : universityForm);
    
    formData.append('targetTab', activeTab);
    formData.append('payload', JSON.stringify(targetPayload));
    if (imageFile && activeTab === 'universities') {
      formData.append('header_image', imageFile);
    }

    const endpoint = editingId ? `update-entry/${editingId}` : 'add-entry';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/${endpoint}`, {
        method: method,
        body: formData
      });
      if ((await res.json()).success) {
        setIsModalOpen(false);
        fetchData();
        fetchLookups();
      }
    } catch (err) { console.error(err); }
  };

  const handleDeleteEntry = async (id) => {
    if (!window.confirm("Are you sure you want to remove this record?")) return;
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/delete-entry/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ targetTab: activeTab })
      });
      if ((await res.json()).success) fetchData();
    } catch (err) { console.error(err); }
  };

  // Pagination Computations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(dataList.length / itemsPerPage);

  return (
    <div>
      {/* TOP CONTROL ACTION BAR */}
      <div style={styles.topActionBar}>
        <div style={styles.tabScrollGroup}>
          {simpleTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id);
                  setDataList([]);
                  setSearchTerm('');
                  setCurrentPage(1);
                }}
                style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}
              >
                <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
              </button>
            );
          })}
        </div>
        <button onClick={handleOpenAddModal} style={styles.addBtn}>
          <Plus size={15} style={{ marginRight: '4px' }} />
          {activeTab === 'courses' ? 'Add New Course' : (activeTab === 'colleges' ? 'Add New College' : 'Add New University')}
        </button>
      </div>

      {/* SEARCH AND INDICATOR STRIP */}
      {/* SEARCH, EXPORT, AND INDICATOR STRIP */}
<div style={styles.filterControlPanel}>
  <div style={styles.searchWrapper}>
    <Search size={16} style={styles.searchIcon} />
    <input
      type="text"
      placeholder={`Search ${activeTab}...`}
      value={searchTerm}
      onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
      style={styles.tableSearchInput}
    />
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
    {/* ➕ Download Excel Button */}
    <button
      type="button"
      onClick={handleExportTabToExcel}
      style={{
        background: '#0f172a',
        color: '#ffffff',
        border: 'none',
        borderRadius: '8px',
        padding: '8px 16px',
        fontSize: '12.5px',
        fontWeight: '700',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)'
      }}
    >
      <Download size={14} /> Download Excel ({activeTab === 'universities' ? 'Universities' : activeTab === 'colleges' ? 'Colleges' : 'Courses'})
    </button>

    <div style={styles.totalIndicator}>
      Total Records: <strong style={{ color: '#459bf2' }}>{dataList.length}</strong>
    </div>
  </div>
</div>

      {/* MASTER DATA TABLE */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <table style={styles.dataTable}>
            {activeTab === 'universities' && (
              <>
                <thead>
                  <tr>
                    <th style={styles.tableTh}>S.No</th>
                    <th style={styles.tableTh}>University Header Image</th>
                    <th style={styles.tableTh}>University Name</th>
                    <th style={styles.tableTh}>Classification</th>
                    <th style={styles.tableTh}>Coordinator</th>
                    <th style={styles.tableTh}>Contact & Email</th>
                    <th style={styles.tableTh}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataList.length === 0 ? (
                    <tr><td colSpan="7" style={styles.noDataTd}>No university connections recorded.</td></tr>
                  ) : (
                    currentItems.map((item, index) => (
                      <tr key={item.id} style={styles.tableTr}>
                        <td style={styles.tableTd}>{index + 1}</td>
                        <td style={styles.tableTd}>
                          {item.header_image ? (
                            <img src={item.header_image} alt="Header" style={{ width: '60px', height: '35px', borderRadius: '4px', objectFit: 'cover' }} />
                          ) : <span style={{ color: '#94a3b8', fontSize: '11px' }}>No Image</span>}
                        </td>
                        <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.university_name}</td>
                        <td style={styles.tableTd}><span style={styles.uniBadge}>{item.university_type}</span></td>
                        <td style={styles.tableTd}>{item.coordinator_name || 'N/A'}</td>
                        <td style={styles.tableTd}>{item.contact_number}<br/><small style={{ color: '#94a3b8' }}>{item.email_address}</small></td>
                        <td style={styles.tableTd}>
                          <div style={styles.actionBtnGroup}>
                            <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
                            <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}

            {activeTab === 'colleges' && (
              <>
                <thead>
                  <tr>
                    <th style={styles.tableTh}>Centre Code</th>
                    <th style={styles.tableTh}>Affiliated University</th>
                    <th style={styles.tableTh}>College Facility Name</th>
                    <th style={styles.tableTh}>Coordinator</th>
                    <th style={styles.tableTh}>Contact Info</th>
                    <th style={styles.tableTh}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataList.length === 0 ? (
                    <tr><td colSpan="6" style={styles.noDataTd}>No colleges added yet.</td></tr>
                  ) : (
                    currentItems.map((item) => (
                      <tr key={item.id} style={styles.tableTr}>
                        <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.college_code}</td>
                        <td style={{ ...styles.tableTd, fontWeight: '600', color: '#1c6ec9' }}>{item.university_name}</td>
                        <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.college_name}</td>
                        <td style={styles.tableTd}>{item.coordinator_name}</td>
                        <td style={styles.tableTd}>{item.contact_number}<br/><small style={{ color: '#94a3b8' }}>{item.email_address}</small></td>
                        <td style={styles.tableTd}>
                          <div style={styles.actionBtnGroup}>
                            <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
                            <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}

            {activeTab === 'courses' && (
              <>
                <thead>
                  <tr>
                    <th style={styles.tableTh}>Code</th>
                    <th style={styles.tableTh}>University / College</th>
                    <th style={styles.tableTh}>Course Name</th>
                    <th style={styles.tableTh}>Eligibility</th>
                    <th style={styles.tableTh}>Type & Duration</th>
                    <th style={styles.tableTh}>Fees</th>
                    <th style={styles.tableTh}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataList.length === 0 ? (
                    <tr><td colSpan="7" style={styles.noDataTd}>No courses found.</td></tr>
                  ) : (
                    currentItems.map((item) => (
                      <tr key={item.id} style={styles.tableTr}>
                        <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.course_code}</td>
                        <td style={styles.tableTd}>
                          <strong style={{ color: '#1c6ec9' }}>{item.university_name}</strong>
                          {item.college_name && <div><small style={{ color: '#64748b' }}>({item.college_name})</small></div>}
                        </td>
                        <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.course_name}</td>
                        <td style={styles.tableTd}><span style={styles.badge}>{item.eligibility}</span></td>
                        <td style={styles.tableTd}>{item.program_type}<br/><small>{item.minimum_duration} Yrs ({item.structure_type})</small></td>
                        <td style={{ ...styles.tableTd, fontWeight: '600', color: '#10b981' }}>₹{Number(item.total_course_fee).toLocaleString('en-IN')}</td>
                        <td style={styles.tableTd}>
                          <div style={styles.actionBtnGroup}>
                            <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit2 size={12} /> Edit</button>
                            <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /> Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}
          </table>
        </div>
      )}

      {/* PAGINATION */}
      {dataList.length > 0 && (
        <div style={styles.paginationDock}>
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}>Previous</button>
          <span style={styles.pageIndicator}>Page <strong>{currentPage}</strong> of {totalPages || 1}</span>
          <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}>Next</button>
        </div>
      )}

      {/* POPUP FORM MODAL */}
      {isModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px' }}>{editingId ? 'Modify Record Entry' : 'Create New Record Entry'}</h3>
              <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <form onSubmit={handleFormSubmit} style={styles.modalForm}>
              
              {/* UNIVERSITIES FORM */}
              {activeTab === 'universities' && (
                <>
                  <div style={styles.formSplitGrid}>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>University Name</label>
                      <input type="text" required placeholder="e.g. Alagappa University" value={universityForm.university_name} onChange={(e) => setUniversityForm({ ...universityForm, university_name: e.target.value })} style={styles.formInput} />
                    </div>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Classification</label>
                      <select value={universityForm.university_type} onChange={(e) => setUniversityForm({ ...universityForm, university_type: e.target.value })} style={styles.formSelect}>
                        <option>State University</option><option>Central University</option><option>Deemed University</option>
                      </select>
                    </div>
                  </div>
                  <div style={styles.formSplitGrid}>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Contact Number</label>
                      <input type="text" required placeholder="Phone number" value={universityForm.contact_number} onChange={(e) => setUniversityForm({ ...universityForm, contact_number: e.target.value })} style={styles.formInput} />
                    </div>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Email Address</label>
                      <input type="email" required placeholder="info@university.edu" value={universityForm.email_address} onChange={(e) => setUniversityForm({ ...universityForm, email_address: e.target.value })} style={styles.formInput} />
                    </div>
                  </div>
                  <div style={styles.formSplitGrid}>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Head Coordinator Name</label>
                      <input type="text" placeholder="Coordinator name" value={universityForm.coordinator_name} onChange={(e) => setUniversityForm({ ...universityForm, coordinator_name: e.target.value })} style={styles.formInput} />
                    </div>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Header Image (Optional)</label>
                      <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} style={styles.formInput} />
                    </div>
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Territorial Jurisdiction Limits</label>
                    <input type="text" required placeholder="e.g. Tamil Nadu, All India" value={universityForm.territorial_jurisdiction} onChange={(e) => setUniversityForm({ ...universityForm, territorial_jurisdiction: e.target.value })} style={styles.formInput} />
                  </div>
                </>
              )}

              {/* COLLEGES FORM */}
              {activeTab === 'colleges' && (
                <>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Select Affiliated University</label>
                    <select required value={collegeForm.university_id} onChange={(e) => setCollegeForm({ ...collegeForm, university_id: e.target.value })} style={styles.formSelect}>
                      <option value="">-- Choose University --</option>
                      {universityOptions.map(u => <option key={u.id} value={u.id}>{u.university_name}</option>)}
                    </select>
                  </div>
                  <div style={styles.formSplitGrid}>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>College / LSC Code</label>
                      <input type="text" required placeholder="e.g. LSC-01" value={collegeForm.college_code} onChange={(e) => setCollegeForm({ ...collegeForm, college_code: e.target.value })} style={styles.formInput} />
                    </div>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Coordinator Name</label>
                      <input type="text" required placeholder="Professor name" value={collegeForm.coordinator_name} onChange={(e) => setCollegeForm({ ...collegeForm, coordinator_name: e.target.value })} style={styles.formInput} />
                    </div>
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>College Facility Name</label>
                    <input type="text" required placeholder="e.g. Govt Arts College" value={collegeForm.college_name} onChange={(e) => setCollegeForm({ ...collegeForm, college_name: e.target.value })} style={styles.formInput} />
                  </div>
                  <div style={styles.formSplitGrid}>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Contact Phone</label>
                      <input type="text" required placeholder="Phone number" value={collegeForm.contact_number} onChange={(e) => setCollegeForm({ ...collegeForm, contact_number: e.target.value })} style={styles.formInput} />
                    </div>
                    <div style={styles.fieldContainer}>
                      <label style={styles.fieldLabel}>Contact Email</label>
                      <input type="email" required placeholder="Email address" value={collegeForm.email_address} onChange={(e) => setCollegeForm({ ...collegeForm, email_address: e.target.value })} style={styles.formInput} />
                    </div>
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Campus Location</label>
                    <input type="text" required placeholder="Location" value={collegeForm.campus_location} onChange={(e) => setCollegeForm({ ...collegeForm, campus_location: e.target.value })} style={styles.formInput} />
                  </div>
                </>
              )}

              {/* COURSES FORM */}
        {activeTab === 'courses' && (
  <>
    {/* University & College Selectors */}
    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Select University *</label>
        <select required value={courseForm.university_id} onChange={(e) => handleUniversityChangeInCourse(e.target.value)} style={styles.formSelect}>
          <option value="">-- Select University --</option>
          {universityOptions.map(u => <option key={u.id} value={u.id}>{u.university_name}</option>)}
        </select>
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Select College (Optional)</label>
        <select value={courseForm.college_id} onChange={(e) => setCourseForm({ ...courseForm, college_id: e.target.value })} style={styles.formSelect}>
          <option value="">-- Independent University Course --</option>
          {filteredColleges.map(c => <option key={c.id} value={c.id}>{c.college_name}</option>)}
        </select>
      </div>
    </div>

    {/* Course Code & Category */}
    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Course Code</label>
        <input type="text" required placeholder="e.g. 101" value={courseForm.course_code} onChange={(e) => setCourseForm({ ...courseForm, course_code: e.target.value })} style={styles.formInput} />
      </div>
 <div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Category Type</label>
  <select 
    value={courseForm.program_type} 
    onChange={(e) => setCourseForm({ ...courseForm, program_type: e.target.value })} 
    style={styles.formSelect}
  >
    <option>Secondary (10th)</option>
    <option>Higher Secondary (12th)</option>
    <option>Under-Graduate (UG)</option>
    <option>Post-Graduate (PG)</option>
    <option>PG Diploma</option>
    <option>Diploma Course</option>
    <option>Certificate Course</option>
  </select>
</div>
    </div>

    {/* Course Name & Free-text Eligibility */}
    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Course Full Name</label>
        <input type="text" required placeholder="e.g. B.B.A (Bachelor of Business Administration)" value={courseForm.course_name} onChange={(e) => setCourseForm({ ...courseForm, course_name: e.target.value })} style={styles.formInput} />
      </div>
     <div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Eligibility Criteria (Text)</label>
  <input 
    type="text" 
    required 
    placeholder="e.g. Pass in 10th / 12th State Board / CBSE / PUC / Any UG" 
    value={courseForm.eligibility} 
    onChange={(e) => setCourseForm({ ...courseForm, eligibility: e.target.value })} 
    style={styles.formInput} 
  />
</div>
    </div>

    {/* Duration, Medium, Total Course Fee, Assignment Marks */}
    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Duration (Years)</label>
        <input type="number" required min="1" max="5" value={courseForm.minimum_duration} onChange={(e) => handleDurationOrStructureChange(e.target.value, courseForm.structure_type)} style={styles.formInput} />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Language Medium</label>
        <select value={courseForm.course_medium} onChange={(e) => setCourseForm({ ...courseForm, course_medium: e.target.value })} style={styles.formSelect}>
          <option>English Medium</option><option>Tamil Medium</option><option>Dual Medium</option>
        </select>
      </div>
    </div>

    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Total Course Fee (₹)</label>
        <input type="number" required placeholder="Total Fee for complete course" value={courseForm.total_course_fee} onChange={(e) => setCourseForm({ ...courseForm, total_course_fee: e.target.value })} style={styles.formInput} />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Assignment Marks</label>
        <input type="number" required placeholder="e.g. 20 or 25" value={courseForm.assignment_marks} onChange={(e) => setCourseForm({ ...courseForm, assignment_marks: e.target.value })} style={styles.formInput} />
      </div>
    </div>

    {/* Academic Structure Radio Buttons */}
    <div style={{ padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
      <label style={{ ...styles.fieldLabel, marginBottom: '6px', display: 'block' }}>Academic Structure</label>
      <div style={{ display: 'flex', gap: '20px' }}>
        <label style={{ fontSize: '12px', cursor: 'pointer' }}>
          <input type="radio" name="struct" value="Semester" checked={courseForm.structure_type === 'Semester'} onChange={(e) => handleDurationOrStructureChange(courseForm.minimum_duration, e.target.value)} /> Semester Wise
        </label>
        <label style={{ fontSize: '12px', cursor: 'pointer' }}>
          <input type="radio" name="struct" value="Non-Semester" checked={courseForm.structure_type === 'Non-Semester'} onChange={(e) => handleDurationOrStructureChange(courseForm.minimum_duration, e.target.value)} /> Non-Semester (Yearly)
        </label>
      </div>
    </div>

    {/* NEW: TERM / SEMESTER TIMELINE DETAILS BLOCK */}
{/* TERM / SEMESTER TIMELINE & FEES DETAILS BLOCK */}
<div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '6px' }}>
  <label style={{ ...styles.fieldLabel, color: '#1c6ec9', marginBottom: '8px', display: 'block' }}>
    {courseForm.structure_type === 'Semester' ? 'Semester' : 'Year'} Wise Fees & Timeline Setup
  </label>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '220px', overflowY: 'auto' }}>
    {(courseForm.semester_details || []).map((sem, sIdx) => (
      <div key={sIdx} style={{ background: '#ffffff', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}>
        <strong style={{ fontSize: '12px', color: '#0f172a', display: 'block', marginBottom: '6px' }}>{sem.term_label}</strong>
        
        {/* Row 1: Semester Fee & Exam Fee */}
        <div style={styles.formSplitGrid}>
          <div style={styles.fieldContainer}>
            <label style={{ fontSize: '10px', color: '#64748b' }}>{sem.term_label} Fee (₹)</label>
            <input 
              type="number" 
              placeholder="e.g. 5000" 
              value={sem.semester_fee} 
              onChange={(e) => handleSemesterDetailChange(sIdx, 'semester_fee', e.target.value)} 
              style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} 
            />
          </div>
          {/* <div style={styles.fieldContainer}>
            <label style={{ fontSize: '10px', color: '#64748b' }}>{sem.term_label} Exam Fee (₹)</label>
            <input 
              type="number" 
              placeholder="e.g. 1000" 
              value={sem.exam_fee} 
              onChange={(e) => handleSemesterDetailChange(sIdx, 'exam_fee', e.target.value)} 
              style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} 
            />
          </div> */}
        </div>

        {/* Row 2: Assignment Duration, Exam Schedule, and Results Timeline */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', marginTop: '6px' }}>
          <div style={styles.fieldContainer}>
            <label style={{ fontSize: '10px', color: '#64748b' }}>Assignment Duration</label>
            <input 
              type="text" 
              placeholder="e.g. 10 Days" 
              value={sem.assignment_duration} 
              onChange={(e) => handleSemesterDetailChange(sIdx, 'assignment_duration', e.target.value)} 
              style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} 
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={{ fontSize: '10px', color: '#64748b' }}>Exam Schedule</label>
            <input 
              type="text" 
              placeholder="e.g. May / Dec" 
              value={sem.exam_schedule_text} 
              onChange={(e) => handleSemesterDetailChange(sIdx, 'exam_schedule_text', e.target.value)} 
              style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} 
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={{ fontSize: '10px', color: '#64748b' }}>Results Timeline</label>
            <input 
              type="text" 
              placeholder="e.g. 45 Days" 
              value={sem.results_timeline_text} 
              onChange={(e) => handleSemesterDetailChange(sIdx, 'results_timeline_text', e.target.value)} 
              style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} 
            />
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


    {/* NEW: REQUIRED DOCUMENTS CHECKLIST */}
<div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '6px' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
    <label style={{ ...styles.fieldLabel, color: '#1c6ec9' }}>Required Eligibility Documents Checklist</label>
    <button type="button" onClick={handleAddDocument} style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1c6ec9', fontSize: '11px', padding: '2px 8px', borderRadius: '4px', cursor: 'pointer' }}>+ Add Doc</button>
  </div>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    {(courseForm.required_documents || []).map((doc, dIdx) => ( 
      <div key={dIdx} style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <input type="text" placeholder="Document Title (e.g. 10th Marksheet)" value={doc} onChange={(e) => handleDocumentChange(dIdx, e.target.value)} style={{ ...styles.formInput, padding: '5px 8px', fontSize: '12px' }} />
        {courseForm.required_documents?.length > 1 && (
          <button type="button" onClick={() => handleRemoveDocument(dIdx)} style={{ background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '4px', cursor: 'pointer', padding: '2px 6px' }}>✕</button>
        )}
      </div>
    ))}
  </div>
</div>

    {/* DYNAMIC SYLLABUS & PAPERS BREAKDOWN */}
<div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '6px', maxHeight: '180px', overflowY: 'auto' }}>
  <label style={{ ...styles.fieldLabel, color: '#1c6ec9', marginBottom: '8px', display: 'block' }}>Syllabus & Subject Papers Breakdown</label>
  {(courseForm.syllabus_structure || []).map((block, termIdx) => (  
    <div key={termIdx} style={{ marginBottom: '10px', background: '#fff', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}>
      <strong style={{ fontSize: '12px', color: '#334155' }}>{block.term}</strong>
      {block.papers?.map((paper, paperIdx) => (
        <div key={paperIdx} style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
          <input type="text" placeholder={`Paper ${paperIdx + 1} Name`} value={paper} onChange={(e) => handlePaperChange(termIdx, paperIdx, e.target.value)} style={{ ...styles.formInput, padding: '4px 8px', fontSize: '12px' }} />
          {block.papers?.length > 1 && (
            <button type="button" onClick={() => removePaperInput(termIdx, paperIdx)} style={{ background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '4px', cursor: 'pointer', padding: '0 6px' }}>✕</button>
          )}
        </div>
      ))}
      <button type="button" onClick={() => addPaperInput(termIdx)} style={{ marginTop: '6px', background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', fontSize: '11px', padding: '3px 8px', borderRadius: '4px', cursor: 'pointer' }}>+ Add Paper</button>
    </div>
  ))}
</div>
  </>
)}

              <div style={styles.formActionDock}>
                <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                <button type="submit" style={styles.formSaveBtn}>Save Entry Record</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
  tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
  tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
  addBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
  tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
  tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  noDataTd: { padding: '30px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
  badge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
  uniBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500' },
  actionBtnGroup: { display: 'flex', gap: '6px', alignItems: 'center' },
  editRowBtn: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  deleteRowBtn: { background: '#fff1f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '620px', maxHeight: '90vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)', overflowY: 'auto' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalForm: { display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '14px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  formInput: { width: '100%', padding: '9px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '9px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
  formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' },
  paginationDock: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #edf2f7' },
  pageIndicator: { fontSize: '13px', color: '#475569' },
  pageBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '6px 14px', color: '#334155', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer' },
  pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' }
};